/**
 * MED-1355: one look for the "No Medley email" badge on every screen.
 * It uses the style guide status pill: warning background and text,
 * radius-sm (3px), 10px uppercase text with 0.3px letter-spacing.
 */
export const NO_MEDLEY_EMAIL_LABEL = 'No Medley email';

export const NO_MEDLEY_EMAIL_BADGE_STYLES = {
  root: {
    backgroundColor: 'var(--medley-bg-warning)',
    color: 'var(--medley-text-warning)',
    border: 'none',
    borderRadius: 3,
    height: 'auto',
    padding: '2px 6px',
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
    minWidth: 'max-content',
  },
} as const;
